import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static outlets = ['cart-line'];

  cartLineOutletConnected(line) {
    line.cart = this;
  }

  cartLineOutletDisconnected(line) {
    this.releaseEdit(line);
  }

  requestEdit(line) {
    if (this.busy) return false;
    if (this.editingLine === line) return true;
    this.editingLine?.commit();
    // The previous editor either closed, submitted, or stayed open with an invalid quantity.
    if (this.busy || this.editingLine) return false;
    this.editingLine = line;
    return true;
  }

  releaseEdit(line) {
    if (this.editingLine === line) this.editingLine = null;
  }

  claimSubmit() {
    if (this.busy || !this.element.checkValidity()) return false;
    // Turbo awaits fetch intercept before submit-start. Lock now to reject same-turn clicks.
    // Invalid requestSubmit fires neither submit nor submit-end, so validate before locking.
    this.busy = true;
    this.editingLine = null;
    return true;
  }

  lock() {
    this.busy = true;
    // Disabled inputs are omitted from FormData; disable only after Turbo has captured it.
    this.element.querySelectorAll('button, input[type=number]').forEach((el) => { el.disabled = true; });
  }

  unlock() {
    this.busy = false;
    this.element.querySelectorAll('button, input[type=number]').forEach((el) => { el.disabled = false; });
  }
}
